import React from 'react'

import {FormRow, Select, AddressSearch} from '../UI/forms/index.js'
import compareAddresses from '../../../utils/compareAddresses.js'

export default class ChooseLocation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            value: '',
            values: [],
            address: props.value || '',
            positionError: false
        }
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customer !== this.props.customer || prevProps.reseller !== this.props.reseller || prevProps.user !== this.props.user || prevProps.locations !== this.props.locations) {
            this.init()
        }
    }

    init() {
        const {reseller, user, customer, locations = [], allowCurrentAddress, allowCustomAddress} = this.props

        const values = []

        if (reseller) {
            if (reseller.settings.branches?.length > 0) {
                reseller.settings.branches.map((branch, index) => {
                    values.push({
                        title: branch.name,
                        value: `branch-${index}`,
                        address: branch.address
                    })
                })
            } else {
                values.push({
                    title: 'Bedrijfslocatie',
                    value: 'companyLocation',
                    address: reseller.settings.companyAddress
                })

                reseller.settings.sublocations?.map((address, index) => {
                    values.push({
                        title: address.name,
                        value: `sublocations-${index}`,
                        address: address
                    })
                })
            }
        }

        if (user) {
            values.push({
                title: `Adres van ${user.name}`,
                value: 'userAddress',
                address: user.address
            })
        }

        if (customer) {
            values.push({
                title: `Adres van ${customer.name}`,
                value: 'customerAddress',
                address: customer.address
            })
        }

        if (locations) {
            locations.map((location, index) => {
                values.push({
                    title: location.name,
                    value: `locations-${index}`,
                    address: location
                })
            })
        }

        if (allowCurrentAddress) {
            values.push({
                title: 'Huidige locatie',
                value: 'currentLocation'
            })
        }

        if (allowCustomAddress) {
            values.push({
                title: 'Anders',
                value: 'custom'
            })
        }

        const selectedValue = values.find((value) => {
            return compareAddresses(value.address, this.props.value)
        })

        this.setState({values, value: selectedValue?.value || (this.props.value ? 'custom' : '')})
    }

    onConfirm(address) {
        const {onChange} = this.props

        if (address) {
            delete address.id

            onChange({
                name: address.name || '',
                street: address.street || '',
                nr: address.nr || '',
                addition: address.addition || '',
                street2: address.street2 || '',
                postalCode: address.postalCode || '',
                city: address.city || '',
                country: address.country || '',
                position: address.position
            })
        } else {
            onChange('')
        }
    }

    async onGetAddress() {
        const position = await new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(resolve, reject)
            }
        })

        return {
            lat: position.coords.latitude, lng: position.coords.longitude, accuracy: position.coords.accuracy
        }
    }

    async onChangeValue(event) {
        const {values} = this.state
        const value = event.target.value

        let address = ''

        if (value === 'custom') {
            this.setState({address: {}})
        } else if (value === 'currentLocation') {
            const position = await this.onGetAddress()

            address = {
                name: 'Huidige locatie',
                street: '',
                street2: '',
                nr: '',
                postalCode: '',
                city: '',
                country: '',
                position
            }
        } else if (value) {
            const location = values.find((l) => l.value === value)
            address = location?.address
        }

        if (value !== 'custom') {
            this.setState({address})
            this.onConfirm(address)
        }

        this.setState({value})
    }

    onChangeAddress(address) {
        if (address.position) { // Prevent onConfirm with an empty address object
            this.setState({address})
            this.onConfirm(address)
        }
    }

    render() {
        const {value, values, address} = this.state
        const {label, disabled, readOnly, allowEmpty} = this.props

        return (
            <FormRow>
                <Select
                    label={label}
                    value={value}
                    onChange={this.onChangeValue.bind(this)}
                    options={values}
                    disabled={disabled}
                    readOnly={readOnly}
                    allowEmpty={allowEmpty}
                />

                <AddressSearch
                    address={address}
                    readOnly={value !== 'custom'}
                    onChange={this.onChangeAddress.bind(this)}
                />
            </FormRow>
        )
    }
}
